import { connect } from 'react-redux';
import SidebarHandoff from '../../components/handoff/SidebarHandoff';
import { hideHandoff } from '../../actionCreators';
import { isInHandoffMode, getSelectedElementType, } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        isOpen: isInHandoffMode(state),
        selectedElementType: getSelectedElementType(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onClose: function () {
            dispatch(hideHandoff());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SidebarHandoff);
